export const GAMES_REQUEST = 'GAMES_REQUEST';
export const GAMES_SUCCESS = 'GAMES_SUCCESS';
export const GAMES_ERROR = 'GAMES_ERROR';

export const LAUNCH_GAME_REQUEST = 'LAUNCH_GAME_REQUEST';
export const LAUNCH_GAME_SUCCESS = 'LAUNCH_GAME_SUCCESS';
export const LAUNCH_GAME_ERROR = 'LAUNCH_GAME_ERROR';
